module.exports = "<div :class=\"{'btn-group':buttons,'btn-group-justified':justified,'btn-group-vertical':vertical}\" :data-toggle=\"buttons&&'buttons'\">\n    <slot></slot>\n  </div>";


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=template&index=0!./src/buttonGroup.vue
// module id = 210
// module chunks = 0